export default __webpack_public_path__ + "static/media/manager_badge.ffb790a4.svg";